// Validate email format
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate phone number (Korean format)
export const validatePhone = (phone: string): boolean => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  // Check if it's a valid Korean phone number (010-XXXX-XXXX)
  return /^01[0-9]{1}[0-9]{7,8}$/.test(cleaned);
};

// Format phone number to display format
export const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  } else if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }

  return phone;
};

// Validate name (Korean or English, min 2 characters)
export const validateName = (name: string): boolean => {
  const nameRegex = /^[a-zA-Z가-힣]{2,}$/;
  return nameRegex.test(name.trim());
};

// Validate driver's license number
export const validateLicenseNumber = (license: string): boolean => {
  // Korean driver's license format: XX-XX-XXXXXX-XX
  const licenseRegex = /^[0-9]{2}-[0-9]{2}-[0-9]{6}-[0-9]{2}$/;
  return licenseRegex.test(license);
};

// Format license number
export const formatLicenseNumber = (license: string): string => {
  const cleaned = license.replace(/\D/g, '');

  if (cleaned.length >= 12) {
    return cleaned.substring(0, 12).replace(/(\d{2})(\d{2})(\d{6})(\d{2})/, '$1-$2-$3-$4');
  }

  return license;
};

// Validate date range
export const validateDateRange = (startDate: Date | null, endDate: Date | null): {
  valid: boolean;
  error?: string;
} => {
  if (!startDate || !endDate) {
    return { valid: false, error: '시작 날짜와 종료 날짜를 선택해주세요.' };
  }

  if (startDate >= endDate) {
    return { valid: false, error: '종료 날짜는 시작 날짜 이후여야 합니다.' };
  }

  const now = new Date();
  if (startDate < now) {
    return { valid: false, error: '과거 날짜는 선택할 수 없습니다.' };
  }

  const hoursDiff = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);
  if (hoursDiff < 5) {
    return { valid: false, error: '최소 대여 시간은 5시간입니다.' };
  }

  return { valid: true };
};
